angular.module('workflow.app')
  .filter 'urlDisplay', () ->
    return (input) ->
      # based on http://stackoverflow.com/a/6168286
      parseUrl = (url) ->
        pattern = RegExp('^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?')
        matches = url.match(pattern)
        {
          scheme: matches[2]
          authority: matches[4]
          path: matches[5]
          query: matches[7]
          fragment: matches[9]
        }

      parseUrl(input or '').authority
